import BackIcon from '../../assets/images/back.svg';
import { Back } from './styles';
import LanguageJson from '../../Language/BackBTN';

export default function BackBTN({ handleBackPage, language }) {
  return (
    <Back onClick={handleBackPage}><img src={BackIcon} alt="back-icon" />{LanguageJson[language].back}</Back>
  )
}